<template>
  <SharedPublitas
    :class="{ 'publitas__display-mode--full': isFull }"
    :publication="mgnlProps.publication"
  />
</template>

<script lang="ts" setup>
import { BrochureViewerBuilder, WrapperProps } from './BrochureViewer.model';

const props = defineProps(WrapperProps);
const mgnlProps = BrochureViewerBuilder.build(props);
const isFull = computed(() => mgnlProps.displayMode === 'fullScreen');
</script>

<style lang="scss" scoped>
.publitas {
  &__display-mode--full {
    position: relative;
    width: 100vw;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }
}
</style>
